import { Configuration } from "@docket/consumer-app-client-typescript-axios";
import { ITokenProvider } from "../../models/TokenProvider";
import { getBaseConfigOptions } from "./base-config";

export default async (provider: ITokenProvider) => {
  return new Configuration({
    ...(await getBaseConfigOptions()),
    accessToken: async () => (await provider.tokens())?.access || "",
  });
};
